export const codes: string[] = [
  "AddDemoPL",
  "DelDemoPL",
  "ConfAlone",
  "ConfLink",
  "ConfDmdTrsf",
  "EmailStkNonPl",
  "DiscProdWeb",
  "ConfNewColl",
  "ConfMatchPtr",
];
